export const beneficiaryDocumentsTranslations = {
    en: {
        // Page Title & Filters
        uploadedDocument: "Uploaded Document",
        generatedLetter: "Generated Letter",
        uploadDocument: "Upload Document",

        // Autocomplete
        selectVisitedCamp: "Select Visited Health Camp",
        unknown: "Unknown",
        unknownAddress: "Unknown Address",

        // Dialog
        addNewDocument: "Add New Document",
        preview: "Preview",

        // Actions
        view: "View",
        viewDocumentTooltip: "View Document",

        // Messages
        beneficiaryDocuments: "Beneficiary Documents"
    },
    mr: {
        // Page Title & Filters
        uploadedDocument: "अपलोड केलेले दस्तऐवज",
        generatedLetter: "तयार केलेले पत्र",
        uploadDocument: "दस्तऐवज अपलोड करा",

        // Autocomplete
        selectVisitedCamp: "भेट दिलेले आरोग्य शिबिर निवडा",
        unknown: "अज्ञात",
        unknownAddress: "अज्ञात पत्ता",

        // Dialog
        addNewDocument: "नवीन दस्तऐवज जोडा",
        preview: "पूर्वावलोकन",

        // Actions
        view: "पहा",
        viewDocumentTooltip: "दस्तऐवज पहा",

        // Messages
        beneficiaryDocuments: "लाभार्थी दस्तऐवज"
    }
};
